import { COLORS, ContentIcons, SystemIcons } from '@laerdal/life-react-components';
import styled from 'styled-components';
import SamaritanButtonComponent from './SamaritanButton';
import { useTranslation } from 'react-i18next';

interface SamaritanTextareaProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  buttonText: string;
  minLength?: number;
  onSubmit?: () => void;
  disabled?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
`;

const TextareaButtonWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledTextarea = styled.textarea`
  width: 100%;
  min-height: 200px;
  border: 1px solid ${COLORS.neutral_300};
  border-radius: 4px;
  padding: 12px;
  padding-bottom: 48px;
  font-family: Lato;
  font-size: 16px;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${COLORS.primary_500};
  }

  &::placeholder {
    color: ${COLORS.neutral_400};
  }
`;

const SubmitButton = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
`;

const NoteContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
`;

const NoteText = styled.span`
  color: var(--life-color-text-subtle);
  font-feature-settings: 'liga' off;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const SamaritanTextarea = ({
  placeholder,
  value,
  onChange,
  buttonText,
  minLength = 20,
  onSubmit,
  disabled = false,
}: SamaritanTextareaProps) => {
  const { t } = useTranslation("cases");

  return (
    <Container>
      <TextareaButtonWrapper>
        <StyledTextarea
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          onKeyDown={(e) => {
            if (e.ctrlKey && e.key === 'Enter' && !disabled && value.length >= minLength && onSubmit) {
              e.preventDefault();
              onSubmit();
            }
          }}
        />
        <SubmitButton>
          <SamaritanButtonComponent
            disabled={disabled || value.length < minLength}
            text={buttonText}
            onClick={onSubmit}
          />
        </SubmitButton>
      </TextareaButtonWrapper>
      {minLength && (
        <NoteContainer>
          <SystemIcons.Information size="16px" />
          <NoteText>{t("Minimum {{minLength}} characters recommended", { minLength })}{value.length > 0 ? `: ${value.length} ${t("characters")}` : ''}</NoteText>
        </NoteContainer>
      )}
    </Container>
  );
};

export default SamaritanTextarea;
